import messages from "./messages.json";

export const datetimeFormats = {
  en: messages.en,
  fr: messages.fr,
  nl: messages.nl,
};
